import { getBaseUrl } from "../config";
import Locale from "./Locale";

class Head {
    constructor() {
        this.headElement = document.head;
    }

    addCanonicalTag() {
        // Remove canonical before re-adding it
        document.querySelectorAll("link[rel='canonical']").forEach(link => link.remove());

        const canonicalUrl = Locale.getLanguage() === 'nl'
          ? Locale.getUrlForLocale('nl', 'nl')
          : Locale.getUrlForLocale('int', 'en');

        this._appendLink('canonical', new URL(canonicalUrl, getBaseUrl()).href);
    }

    addHreflangLinks() {
        // Remove only hreflang alternate links (not others like AMP etc.)
        document.querySelectorAll("link[rel='alternate'][hreflang]")
          .forEach(link => link.remove());

        const hreflangConfigs = [
            ['nl-NL', 'nl', 'nl'],
            ['en-NL', 'nl', 'en'],
            ['en-GB', 'gb', 'en'],
            ['en-US', 'us', 'en'],
            ['en-CA', 'ca', 'en'],
            ['en-DE', 'de', 'en'],
            ['en-IT', 'it', 'en'],
            ['en',    'int', 'en'],
            ['x-default', 'int', 'en']
        ];

        hreflangConfigs.forEach(([langCode, region, lang]) => {
            const href = new URL(Locale.getUrlForLocale(region, lang), getBaseUrl()).href;
            this._appendLink('alternate', href, langCode);
        });
    }

    _appendLink(rel, href, hreflang = null) {
        const link = document.createElement('link');
        link.rel = rel;
        link.href = href;
        if (hreflang) link.hreflang = hreflang;
        this.headElement.appendChild(link);
    }
}

export default new Head();
